import { render, staticRenderFns } from "./SearchDataPatient.vue?vue&type=template&id=2f74876e&scoped=true"
import script from "./SearchDataPatient.vue?vue&type=script&lang=js"
export * from "./SearchDataPatient.vue?vue&type=script&lang=js"
import style0 from "./SearchDataPatient.vue?vue&type=style&index=0&id=2f74876e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f74876e",
  null
  
)

export default component.exports